import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ACCESS_MODE, DeviceType, Template } from '@horasys/bellplus/common/types';
import { SET_PROGRESS } from './progressSlice';
import { SEND_MESSAGE } from './errorHandlingSlice';
import { deleteTemplate, getTemplatesList, getTemplatesListByDeviceTypeId } from 'services/template.service';

export interface TemplateState {
    adminlist: Array<any>;
    standardList: Array<any>;
    clientList: Array<any>;
    clientId: number;
    error: any;
    loading: boolean;
    mode: ACCESS_MODE;
    selectedId: number;
    template: Template;
    tempDeviceTypeTemplateList: Array<Template>;
}
const emptyDeviceType: DeviceType = {
    id: 0,
    deviceType: '',
    qrScannerEnabled: false,
    height: 0,
    width: 0,
};
const emptyTemplate: Template = {
    name: '',
    templateUrl: '',
    duration: 0,
    thumbnailAssetId: 2,
    assets: [],
    id: 0,
    deviceType: emptyDeviceType,
    standard: false,
};
const initialState: TemplateState = {
    adminlist: [],
    standardList: [],
    clientId: 0,
    clientList: [],
    error: null,
    loading: false,
    mode: 'CREATE',
    selectedId: 0,
    tempDeviceTypeTemplateList: [],
    template: emptyTemplate,
};
const popUpSlice = createSlice({
    name: 'template',
    initialState,
    reducers: {
        GET_TEMPLATES_LIST: (state, action: PayloadAction<any>): TemplateState => {
            return {
                ...state,
                adminlist: action.payload,
            };
        },
        GET_TEMPLATES_LIST_BY_DEVICE_TYPE: (state, action: PayloadAction<any>): TemplateState => {
            return {
                ...state,
                tempDeviceTypeTemplateList: [
                    ...state.tempDeviceTypeTemplateList,
                    ...action.payload,
                ],
            };
        },
        RESET_TEPLATES_BY_DEVICE_TYPE: (state, action: PayloadAction<any>): TemplateState => {
            return {
                ...state,
                tempDeviceTypeTemplateList: [],
            };
        },
        RESET_TEMPLATE_FORM: (state, action: PayloadAction<any>): TemplateState => {
            return {
                ...state,
                template: emptyTemplate,
            };
        },
        ADD_TEMPLATE: (state, action: PayloadAction<any>): TemplateState => {
            return {
                ...state,
                tempDeviceTypeTemplateList: [
                    ...state.tempDeviceTypeTemplateList,
                    action.payload,
                ],
            };
        }
    }
})

export const { GET_TEMPLATES_LIST, GET_TEMPLATES_LIST_BY_DEVICE_TYPE, RESET_TEPLATES_BY_DEVICE_TYPE, RESET_TEMPLATE_FORM, ADD_TEMPLATE } = popUpSlice.actions
export default popUpSlice.reducer


export const getAllTemplateDetailsByDeviceType = (deviceTypeId: number): any => async (
    dispatch: any,
) => {
    try {
        dispatch(SET_PROGRESS(true));
        const templates = await getTemplatesListByDeviceTypeId(deviceTypeId);
        dispatch(GET_TEMPLATES_LIST_BY_DEVICE_TYPE(templates));
        dispatch(SET_PROGRESS(false));
    } catch (error: any) {
        dispatch(SEND_MESSAGE({ message: error, type: 'error' }));
        dispatch(SET_PROGRESS(false));
    }
};


export const deleteTemplateThunkById = (
    templateId: number,
    setTemplatesList: any,
) => async (dispatch: any) => {
    try {
        dispatch(SET_PROGRESS(true));
        await deleteTemplate(templateId);
        dispatch(SET_PROGRESS(false));
        dispatch(SEND_MESSAGE({ message: 'DELETED SUCCESSFULLY', type: 'success' }));
        const templates = await getTemplatesList();
        setTemplatesList(templates);
    } catch (error: any) {
        dispatch(SEND_MESSAGE({ message: error, type: 'error' }));
        dispatch(SET_PROGRESS(false));
    }
};
